// Field-specific errors are frequently of the form:
// "fieldName" with value "invalid_value" fails to match..."
const ERROR_FIELD_REGEX = /^"(\S+)"/;

const extractErrorDetails = (error: any) => {
  if (!error) return null;
  // Error cause is found in a couple of different places...

  if (!error.cause) return `ref ${error?.message}`;

  const errorMessage = error.cause.context?.meta?.details
    || error.cause.context?.details;

  if (errorMessage) {
    const match = errorMessage.match(ERROR_FIELD_REGEX);
    if (!match) return errorMessage;

    if (match[1]) return `There was a problem with "${match[1]}"`;
  }

  return errorMessage;
};

export default extractErrorDetails;
